export const API_URL = process.env.REACT_APP_API_URL as string;

export const URL_CHAT_BOT = 'https://dc-chatbot.orientalbank.com';
